import { useLingui } from '@lingui/react';
import { SegmentedControl, SimpleGrid, Stack } from '@mantine/core';
import { useRouter } from 'next/navigation';
import classes from './LootBoxes.module.css';
import { LootBoxesCard } from './LootBoxesCard';
import { boxes } from './data';
export const LootBoxesList: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const router = useRouter();
  const handlePlaySwitched = (value: string) => {
    if (value === 'play') router.push('/lootboxes-spin');
  };
  return <Stack mt={20} pb={72}>
      <SegmentedControl size="xl" w={218} data={[{
      value: 'play',
      label: i18n._('Play')
    }, {
      value: 'boxes',
      label: i18n._('My LootBoxes')
    }]} defaultValue="boxes" classNames={classes} onChange={handlePlaySwitched} />

      <SimpleGrid cols={{
      base: 2,
      sm: 3,
      md: 4,
      xl: 5
    }} spacing={{
      base: 10,
      sm: 16,
      lg: 20
    }}>
        {boxes.map(item => <LootBoxesCard key={item.id} {...item} />)}
      </SimpleGrid>
    </Stack>;
};